import React, { Component } from 'react';
import { connect } from 'react-redux'
import { Link, Redirect } from 'react-router-dom'
import { Form, Errors, actions, Control } from 'react-redux-form';
import { FormGroup, FormControl, Row, Col, Checkbox } from 'react-bootstrap';
import moment from 'moment'
import ImageUpload from '../common/form/elements/image-upload'
import PageTitle from '../common/page-title'
import ConfirmPopup from '../common/confirm-popup'
import ArrowButton from '../common/button-arrow'
import InlineCKEditor from '../common/editor/inline-editor'
import { getMyProfile, saveMyProfile, closeAccount } from '../../actions/user'
import { loadPageContent } from '../../actions/content';

import './style.css';
import MarketingPreferences from "../about-you/marketing-preferences";
import KeyAccountManagerDetails from './key-account-manager-details';

class MyProfile extends Component {
  constructor(props) {
    super(props);

    this.pageSlug = 'my-profile';
    this.state = {
      showDelete: false,
      image: ''
    }
  }

  componentWillMount() {
    this.props.dispatch(getMyProfile());
    this.props.dispatch(loadPageContent(`api/pages/${this.pageSlug}`));
  }

  onSubmit = (payload) => {
    const payLoad = { ...payload };
    const { dispatch, comms_mobile, comms_email } = this.props;

    dispatch(actions.submitFields('deep.my_profile', saveMyProfile(payLoad)));

    if (!comms_mobile) {
      dispatch(actions.change('deep.my_profile.mobile', ''));
    }

    if (!comms_email) {
      dispatch(actions.change('deep.my_profile.email', ''));
    }

  };

  onDelete = (result) => {
    this.setState({ ...this.state, showDelete: false });
    if (result) {
      this.props.dispatch(closeAccount);
    }
  };

  onImageLoaded = (data) => {
    this.setState({ ...this.state, image: data });
  };

  handleContentSaved = () => {
    this.props.dispatch(loadPageContent(`api/pages/${this.pageSlug}`));
  };

  render() {
    const profile = this.props.profile.attributes;
    const isUserNormalLoggedIn = !profile['pseudo-login'];
    const isAccountManager = profile['user-group'] === 'account_manager';
    const panelSize = isAccountManager ? 'panel--large' : 'panel--medium';
    const image = profile.links ? profile.links.image : undefined;

    return (
      <div className="container">
        <Row className="my-profile">
          <Col lg={12} className="my-profile--title">
            <PageTitle>My profile</PageTitle>
          </Col>

          <Col lg={12}>
            <InlineCKEditor identifier={`${this.pageSlug}_content_text`}
              onContentSaved={this.handleContentSaved}
              contents={this.props.contents[`${this.pageSlug}_content_text`]} />
          </Col>

          <Form model="deep.my_profile"
            onSubmit={(payload) => this.onSubmit(payload)}>
            <Col lg={6} className={`panel panel--primary ${panelSize}`}>
              <Col className="col-lg-6 image--container">
                <ImageUpload onImageLoaded={this.onImageLoaded}
                  source={image}
                  sizeLimit={1024 * 1024}
                  label=''
                  alt=''
                  className="circular--portrait img-responsive center-block"
                  buttonLabel='Change'
                  type={['image/png', 'image/jpg', 'image/jpeg']} />
              </Col>
              <Col className="col-lg-6 personal--details">
                <h4>Personal Details</h4>

                <table id="personal--details">
                  <tr>
                    <td className="col-form-label">Title</td>
                    <td className="col-form-data readonly">{profile.title}</td>
                  </tr>
                  <tr>
                    <td className="col-form-label">First Name</td>
                    <td className="col-form-data readonly">{profile['first-name']}</td>
                  </tr>
                  <tr>
                    <td className="col-form-label">Last Name</td>
                    <td className="col-form-data readonly">{profile['last-name']}</td>
                  </tr>
                  <tr>
                    <td className="col-form-label">D.O.B.</td>
                    <td className="col-form-data readonly">{moment(profile['date-of-birth']).format('DD/MM/YYYY')}</td>
                  </tr>
                </table>
              </Col>
              {isAccountManager && profile['key-account-email'] !== null &&
                <KeyAccountManagerDetails
                  keyAccountFirstName={profile['key-account-first-name']}
                  keyAccountLastName={profile['key-account-last-name']}
                  keyAccountEmail={profile['key-account-email']}
                />
              }
              <Col className="col-lg-6">
                {
                  !this.props.user.attributes['pseudo-login'] &&
                  <div className="details--buttons">
                    <Link to="/update-password">
                      <ArrowButton submit={false}
                        arrow={false}
                        color={"red"}
                        className={"btn btn-form btn-form-red"}
                        ghost={true}>Set new  password</ArrowButton>
                    </Link>

                    <Link to="/update-security-questions">
                      <ArrowButton submit={false}
                        color={"red"}
                        arrow={false}
                        ghost={true}>Update security questions</ArrowButton>
                    </Link>
                  </div>
                }
              </Col>
            </Col>
            <Col lg={6} className={`panel panel--secondary ${panelSize}`}>
              <h4>Communication Preferences</h4>
              <Errors
                show={{ touched: true }}
                className="errors"
                model="deep.about_you.user"
                messages={{
                  communication: 'You must select at least one communication preference.'
                }} />
              <br />
              <Col lg={3}>
                <FormGroup>
                  <Control.checkbox model=".comms_email" component={Checkbox}>Email</Control.checkbox>
                </FormGroup>
              </Col>
              <Col lg={3}>
                <FormGroup>
                  <Control.checkbox model=".comms_mobile" component={Checkbox}>Mobile</Control.checkbox>
                </FormGroup>
              </Col>
              <Col lg={12}>
                <FormGroup controlId="email">
                  <Control.text
                    model=".email"
                    type="email"
                    placeholder="Email"
                    disabled={!this.props.comms_email}
                    component={FormControl} />

                  <Errors
                    show={{ touched: true, focus: false }}
                    className="errors"
                    model=".email" />
                </FormGroup>
              </Col>

              <Col lg={12}>
                <FormGroup controlId="mobile">
                  <Control.text
                    model=".mobile"
                    type="tel"
                    placeholder="Mobile Number"
                    disabled={!this.props.comms_mobile}
                    component={FormControl} />

                  <Errors
                    show={{ touched: true, focus: false }}
                    className="errors"
                    model=".mobile" />
                </FormGroup>

              </Col>
              {isUserNormalLoggedIn && (
                <MarketingPreferences title={<h4>Update your preferences</h4>} type="update" />
              )}
            </Col>
            <Col>
              <ArrowButton color="grey"
                className="pull-right"
                disabled={!this.props.formValid || !(this.props.comms_email || this.props.comms_mobile)}>Save</ArrowButton>

              {profile['user-group'] === 'staff' &&
                <ArrowButton color="red"
                  className="pull-right close-account-button"
                  arrow={false}
                  submit={false}
                  onClick={() => this.setState({ ...this.state, showDelete: !this.state.showDelete })}>Close account</ArrowButton>
              }

              {
                this.state.showDelete &&
                <ConfirmPopup onClose={this.onDelete} >
                  <p>Are you sure you want to close your account?
                    If you close your account you will no longer be able to access <b>ignite</b></p>
                </ConfirmPopup>
              }

              {
                this.props.redirectAfterDelete && <Redirect to="/logout" />
              }
            </Col>
          </Form>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    profile: state.currentUser.profile,
    formValid: state.deep.forms.my_profile.$form.valid,
    comms_mobile: !!state.deep.my_profile.comms_mobile,
    comms_email: !!state.deep.my_profile.comms_email,
    redirectAfterDelete: state.currentUser.redirectAfterDelete,
    user: state.viewConfig.profile,
    contents: state.content.list
  };
};

export default connect(mapStateToProps)(MyProfile);



// WEBPACK FOOTER //
// ./src/components/my-profile/index.jsx